import Form from './vue-components/form/form';
import FormGroup from './vue-components/form/form-group';
import CheckboxSwitch from './vue-components/form/checkbox-switch';
import Radio from './vue-components/form/radio';
import Datatable from './vue-components/datatable/datatable';
import AutomaticPost from './vue-components/automatic-post';
import VModal from 'vue-js-modal';

Vue.component('v-form', Form);
Vue.component('v-form-group', FormGroup);
Vue.component('v-checkbox-switch', CheckboxSwitch);
Vue.component('v-radio', Radio);

Vue.component('v-datatable', Datatable);
Vue.component('v-automatic-post', AutomaticPost);

Vue.use(VModal, { dynamic: true, injectModalsContainer: true })

require('./media-library/index');
